import * as React from 'react';
import { Col, Row, Divider, Input, Checkbox } from 'antd';

import Form, { FormItem } from '../../../components/Form';
import { Title } from '../../../components/Layout/components';
import CountrySelect from 'src/components/Others/CountrySelect';

interface IBusinessDetailProps {
  business: GQL.IBusiness;
  onSave: (business: GQL.IBusiness) => void;
  onCancel: () => void;
}

interface IBusinessDetailState {
  business: GQL.IBusiness;
}

export default class BusinessDetail extends React.Component<IBusinessDetailProps, IBusinessDetailState> {

  public constructor(props: IBusinessDetailProps) {
    super(props);

    this.state = {
      business: props.business || {},
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { business } = this.state;

    return (
      <div>
        <Title>
          {business
            ? `Business ${business.name ? `"${business.name}"` : ''}`
            : `Business`}
        </Title>

        <Divider />
        <Form
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24}>
              <FormItem label={'Name'} required={true}>
                <Input
                  name={'name'}
                  autoFocus={true}
                  required={true}
                  placeholder="Internal name"
                  addonBefore={'Internal'}
                  defaultValue={business.name || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Company'} required={true}>
                <Input
                  name={'company'}
                  required={true}
                  defaultValue={business.company || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <Row gutter={16}>
                <Col span={8}>
                  <FormItem label={'Street address'}>
                    <Input
                      name={'addressLine1'}
                      defaultValue={business.addressLine1 || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={8}>
                  <FormItem label={'Address line 2'}>
                    <Input
                      name={'addressLine2'}
                      defaultValue={business.addressLine2 || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <FormItem label={'City'}>
                    <Input
                      name={'city'}
                      defaultValue={business.city || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={3}>
                  <FormItem label={'Zip'}>
                    <Input
                      name={'zip'}
                      defaultValue={business.zip || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
              </Row>
              <FormItem label={'County / State'}>
                <Input
                  name={'countyState'}
                  defaultValue={business.countyState || ''}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Country'}>
                <CountrySelect
                  name={'country'}
                  value={business.country || undefined}
                  hideRegions={false}
                  onChange={(e: any, country: GQL.ICountry) => this.onChange({ target: { name: 'country', value: country ? country.name : null } })}
                />
              </FormItem>
              <Row gutter={16}>
                <Col span={6}>
                  <FormItem label={'Vat number'}>
                    <Input
                      name={'vatNumber'}
                      defaultValue={business.vatNumber || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label={'Registration number'}>
                    <Input
                      name={'registrationNumber'}
                      defaultValue={business.registrationNumber || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <FormItem label={'Phone'}>
                    <Input
                      name={'phone'}
                      defaultValue={business.phone || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label={'E-mail'}>
                    <Input
                      name={'email'}
                      defaultValue={business.email || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label={'E-mail for notifications'}>
                    <Input
                      name={'emailForNotification'}
                      defaultValue={business.emailForNotification || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label={'Web'}>
                    <Input
                      name={'web'}
                      defaultValue={business.web || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <FormItem label={'Bank name'}>
                    <Input
                      name={'bankName'}
                      defaultValue={business.bankName || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={6}>
                  <FormItem label={'IBAN'}>
                    <Input
                      name={'iban'}
                      defaultValue={business.iban || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={4}>
                  <FormItem label={'Swift'}>
                    <Input
                      name={'swift'}
                      defaultValue={business.swift || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
                <Col span={8}>
                  <FormItem label={'Bank account number'}>
                    <Input
                      name={'bankAccountNumber'}
                      defaultValue={business.bankAccountNumber || ''}
                      onChange={this.onChange}
                    />
                  </FormItem>
                </Col>
              </Row>
              <FormItem>
                <Checkbox
                  name={'default'}
                  checked={business.default !== null ? business.default : false}
                  onChange={e => this.onChange(e)}
                >
                  Default
                </Checkbox>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.business[name], [language]: inputValue } }
      : { [name]: inputValue });

    this.setState({
      business: { ...this.state.business, ...newValue }
    });
  }

  private async save() {
    const business = { ...this.state.business };
    this.props.onSave(business);
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Business/BusinessDetail/BusinessDetail.tsx